import { ProductJsonLd, ProductJsonLdProps } from "next-seo"

import { Product, Review } from "@secureo/common/typings/Product"

export const formatReviews = (reviews: Review[]) => {
	const formattedReviews: ProductJsonLdProps["reviews"] = reviews.map((review) => {
		const { authorName, createdAt, title, text: reviewBody, rating } = review

		return {
			author: {
				type: "Person",
				name: authorName,
			},
			name: title,
			datePublished: createdAt,
			reviewBody,
			reviewRating: {
				bestRating: String(rating),
				ratingValue: String(rating),
				worstRating: String(rating),
			},
		}
	})

	return formattedReviews
}

const ProductStructuredData = ({ product, reviews, locale, singleGrossPriceCents }: Props) => {
	const { name, sku, slug, variants, shortDescription = "", reviewRatingStatistics } = product

	const masterVariant = variants?.[0]
	const { attributes, images = [] } = masterVariant

	const url = `${process.env.NEXT_PUBLIC_HOST}/${locale}/p/${slug}`

	const brand = attributes?.manufacturer ?? null

	const { averageRating: ratingValue, count: reviewCount } = reviewRatingStatistics

	const formattedReviews = formatReviews(reviews)

	const props: Pick<ProductJsonLdProps, "aggregateRating" | "reviews" | "description"> = {}

	if (ratingValue > 0) {
		props.reviews = formattedReviews
		props.aggregateRating = {
			ratingValue: String(ratingValue),
			reviewCount: String(reviewCount),
		}
	}

	const descriptionContainsHTML =
		shortDescription?.includes("<") || shortDescription?.includes("/>")
	if (!descriptionContainsHTML) props.description = shortDescription

	return (
		<ProductJsonLd
			sku={sku}
			productName={name}
			images={images}
			brand={brand}
			offers={{
				price: String(singleGrossPriceCents / 100),
				priceCurrency: "EUR",
				itemCondition: "http://schema.org/NewCondition",
				availability: "http://schema.org/InStock",
				seller: {
					name: "Digitalzylinder Shop",
				},
				url,
			}}
			{...props}
		/>
	)
}

interface Props {
	product: Product
	reviews: Review[]
	locale: string
	singleGrossPriceCents: number
}

export default ProductStructuredData
